module.exports = __webpack_public_path__ + "static/media/heco-logo.a6b2ef48.png";